// extracted by mini-css-extract-plugin
module.exports = {"link":"UserProfileMenu_link__9s_M6","navItem":"UserProfileMenu_navItem__gMLFG"};